import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ps-ingredient-editor" }
const _hoisted_2 = { class: "ingredient-row" }
const _hoisted_3 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_4 = ["onUpdate:modelValue"]
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("h3", null, "Ingredients", -1)),
    _createVNode(_component_draggable, {
      modelValue: _ctx.rows,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rows) = $event)),
      "item-key": (el) => el,
      handle: ".drag-handle",
      onEnd: _ctx.emitUpdate
    }, {
      item: _withCtx(({ element, index }) => [
        _createElementVNode("div", _hoisted_2, [
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "drag-handle" }, "☰", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": ($event: any) => ((element.name) = $event),
            placeholder: _ctx.capitalize(element.rowType) + ' name',
            class: "name",
            onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitUpdate && _ctx.emitUpdate(...args)))
          }, null, 40, _hoisted_3), [
            [_vModelText, element.name]
          ]),
          (element.rowType == 'ingredient')
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                "onUpdate:modelValue": ($event: any) => ((element.quantity) = $event),
                placeholder: "Qty",
                class: "quantity",
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitUpdate && _ctx.emitUpdate(...args)))
              }, null, 40, _hoisted_4)), [
                [_vModelText, element.quantity]
              ])
            : _createCommentVNode("", true),
          (element.rowType == 'ingredient')
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                "onUpdate:modelValue": ($event: any) => ((element.unit) = $event),
                placeholder: "Unit",
                class: "unit",
                onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.emitUpdate && _ctx.emitUpdate(...args)))
              }, null, 40, _hoisted_5)), [
                [_vModelText, element.unit]
              ])
            : _createCommentVNode("", true),
          (element.rowType == 'ingredient')
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 2,
                "onUpdate:modelValue": ($event: any) => ((element.notes) = $event),
                placeholder: "Notes",
                class: "notes",
                onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.emitUpdate && _ctx.emitUpdate(...args)))
              }, null, 40, _hoisted_6)), [
                [_vModelText, element.notes]
              ])
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "remove",
            onClick: ($event: any) => (_ctx.removeIngredient(index))
          }, "X", 8, _hoisted_7)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "item-key", "onEnd"]),
    _createElementVNode("button", {
      type: "button",
      class: "add",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addIngredient('ingredient')))
    }, "+ Add Ingredient"),
    _createElementVNode("button", {
      type: "button",
      class: "add",
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addIngredient('section')))
    }, "+ Add Section")
  ]))
}